import { Button, Card, CardActions, CardContent, CardHeader, Container, FormControlLabel, Snackbar, Stack, Switch, TextField } from '@mui/material'
import { initUser, updateUser, type UpdateUser } from '../firebase/firestore'
import Header from './Header'
import { useState } from 'react'
import { lightYellow } from '../theme'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { User } from '../firebase/validator'
import AvaterSelecter from './AvaterSelecter'
import { getAuth } from 'firebase/auth'

type Props = {
  user?: User
  userId: string
}
const SettingUser: React.FC<Props> = ({user, userId}) => {
  const [icon_id, setIconId] = useState<string>(user?.icon || '')
  const queryClient = useQueryClient()
  const [snackbar_msg, setSnackbarMsg] = useState('')
  const [email, setEmail] = useState(user?.email || '')
  const mutation = useMutation<User, unknown, UpdateUser>({
    mutationFn: async data=> {
      if (!user) return initUser(userId, data)
      updateUser(userId, data)
      return {...user, ...data}
    },
    onError: ()=> { setSnackbarMsg('設定に失敗しました') },
    onSuccess: data=> {
      queryClient.setQueryData(['me'], data)
      setSnackbarMsg('設定が完了しました')
    },
  })

  return <>
    <Header/>

    <main>
      <Container maxWidth='md'>
        <Card sx={{mt: 2, bgcolor: lightYellow}}>
          <form
            onSubmit={e=> {
              e.preventDefault()
              const formdata = new FormData(e.currentTarget)
              const user_setting: UpdateUser = {
                name: formdata.get('name' ) as string,
                icon: icon_id,
                email: (formdata.get('email') as string) || '',
                notification: formdata.get('notification') === 'on',
              }
              mutation.mutate(user_setting)
            }}
          >
            <CardHeader
              title='ユーザー設定'
              slotProps={{
                title: {variant: 'h1', fontSize: 32}
              }}
            />
            <CardContent>
              <TextField
                type='text'
                label='名前'
                name='name'
                defaultValue={user?.name || ''}
                placeholder='Name'
                variant='outlined'
                required fullWidth
                disabled={mutation.isPending}
                slotProps={{
                  htmlInput: {
                    maxLength: 20
                  }
                }}
                helperText='20文字以内で入力してください'
              />

              <label>アバター</label>
              <AvaterSelecter avater_id={icon_id} setAvater={setIconId}/>

              {/* キャストの場合だけで良いかも */}
              <Stack direction='row' spacing={2} sx={{mt: 2}}>
                <TextField
                  type='email'
                  label='メールアドレス'
                  name='email'
                  value={email}
                  placeholder='Email'
                  variant='outlined'
                  fullWidth
                  disabled={mutation.isPending}
                  onChange={e=> { setEmail(e.target.value) }}
                />
                <Button
                  variant='contained'
                  color='secondary'
                  onClick={()=> {
                    const auth = getAuth()
                    setEmail(auth.currentUser?.email || email)
                    setSnackbarMsg('メールアドレスをコピーしました')
                  }}
                  disabled={mutation.isPending}
                >
                  ログイン時のアドレスを利用
                </Button>
              </Stack>
              <FormControlLabel
                control={
                  <Switch
                    name='notification'
                    defaultChecked={user?.notification}
                    disabled={mutation.isPending}
                  />
                }
                label='通知を受け取る'
                labelPlacement='start'
              />
            </CardContent>
            <CardActions>
              <Button
                type='submit'
                variant='contained'
                color='secondary'
                disabled={mutation.isPending}
                fullWidth
              >
                設定
              </Button>
            </CardActions>
          </form>
        </Card>
      </Container>
    </main>

    <Snackbar
      open={Boolean(snackbar_msg)}
      autoHideDuration={6000}
      onClose={()=> { setSnackbarMsg('') }}
      message={snackbar_msg}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
    />
  </>
}
export default SettingUser